<template>
  <div>
    <h4><i class="fas fa-donate"></i> SHBE</h4>
    <div v-if="shbe.length === 0">No related SHBE records.</div>
    <b-tabs v-if="shbe.length > 0">
      <b-tab title="Adults" v-if="records.length > 0" active>
        <b-table :items="records" :fields="['record_type', 'first_name', 'dob', 'authority', 'address_line_1', 'tenancy_type']">
          <template #head(first_name)>Name</template>
          <template #head(dob)>Born</template>
          <template #cell(first_name)="data">
            <div>{{ data.value }} {{ data.item.last_name }}</div>
            <code>{{ data.item.national_insurance_number }}</code>
          </template>
          <template #cell(tenancy_type)="data">
            <div class="claim_ref">HB Claim Ref: <code>{{ data.item.housing_benefit_claim_reference_number }}</code></div>
            {{ describe_claim(data.item) }}
          </template>
          <template #cell(authority)="data"><authority :authority="data.value"/></template>
        </b-table>
      </b-tab>

      <b-tab title="Partners" v-if="partners.length > 0">
        <b-table :items="partners" :fields="['p_first_name', 'p_dob', 'first_name', 'authority', 'p_total_capital', 'address_line_1']">
          <template #head(p_first_name)>Name</template>
          <template #head(p_dob)>Born</template>
          <template #head(first_name)>Related to</template>
          <template #head(p_total_capital)>Total Capital</template>
          <template #head(address_line_1)>Address</template>
          <template #cell(p_first_name)="data">
            <div>{{ data.item.p_first_name || 'No name on record' }} {{ data.item.p_last_name }}</div>
            <code>{{ data.item.p_national_insurance_number }}</code>
          </template>
          <template #cell(first_name)="data">{{ data.value}} {{ data.item.last_name }}</template>
          <template #cell(p_total_capital)="data">{{ data.value | currency }}</template>
          <template #cell(address_line_1)="data">{{ data.value }}<br/>{{ data.item.address_line_2 }}</template>
          <template #cell(authority)="data"><authority :authority="data.value"/></template>
        </b-table>
      </b-tab>

      <b-tab title="Children" v-if="children.length > 0">
        <b-table :items="children" :fields="['child_first_name', 'child_dob']">
          <template #head(child_first_name)>Child&lsquo;s name</template>
          <template #head(child_dob)>Born</template>
          <template #cell(child_first_name)="data">
            <div>{{ data.value }} {{ data.item.child_last_name }}</div>
            <code>{{ data.item.child_national_insurance_number }}</code>
          </template>
        </b-table>
      </b-tab>

      <b-tab title="Landlords" v-if="landlords.length > 0">
        <b-table :items="landlords" :fields="['landlord_first_name', 'landlord_post_code']">
          <template #head(landlord_first_name)>Landlord&lsquo;s name</template>
          <template #head(landlord_post_code)>Address</template>
          <template #cell(landlord_first_name)="data">{{ data.value }} {{ data.item.landlord_last_name }}</template>
          <template #cell(landlord_post_code)="data">
            {{ data.item.landlord_address_line_1 }}<br/>
            {{ data.item.landlord_address_line_2 }}<br/>
            {{ data.value }}
          </template>
        </b-table>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Authority from '../Authority.vue'

export default {
  components: { Authority },
  props: ['shbe'],
  computed: {
    records() {
      return this.shbe.filter(r => r.record_type !== 'S');
    },
    children() {
        return this.shbe.filter(r => r.record_type === 'S');
    },
    partners() {
        return this.shbe.filter(r => (r.p_national_insurance_number || '') !== '');
    },
    landlords() {
      return this.shbe.filter(r => (r.landlord_post_code || '') !== '');
    },
  },
  methods: {
    describe_claim(occupant) {
        let res = '';
        switch (occupant.record_type) {
            case 'D':
                res += 'Decided ';
                break;
            case 'A':
                res += 'Undecided ';
                break;
        }

        let hasHb = (occupant.housing_benefit_claim_reference_number || '').length > 0;
        let hasCts = (occupant.council_tax_reduction_scheme_number || '').length > 0;

        if (hasHb) {
            res += 'Housing Benefits ';
        }

        if (hasHb && hasCts) {
            res += ' and ';
        }

        if (hasCts) {
            res += 'Council Tax Support';
        }

        return res;
    },
  },
}
</script>

<style scoped>
.claim_ref {
  color: #aaa;
  font-size: 85%;
}
</style>
